
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_45199","data-name":"Group 45199","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-get-building"}},[_c('rect',{attrs:{"id":"Rectangle_15170","data-name":"Rectangle 15170","width":"22","height":"22","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_45198","data-name":"Group 45198","clip-path":"url(#clip-path-get-building)"}},[_c('path',{attrs:{"id":"Path_32388","data-name":"Path 32388","d":"M14.409 13.251a5.7 5.7 0 01-5.546 7.008V15.7m5.546-2.45a14.229 14.229 0 005.85-11.51A14.225 14.225 0 008.75 7.591m5.66 5.66A14.182 14.182 0 018.863 15.7M8.75 7.591a5.7 5.7 0 00-7.009 5.546H6.3m2.45-5.546a14.171 14.171 0 00-2.45 5.546M8.864 15.7l-.3.057a14.363 14.363 0 01-2.325-2.325l.057-.3m-2.122 2.274A4.266 4.266 0 002.505 19.5a4.266 4.266 0 004.088-1.669m8.68-9.675a1.425 1.425 0 11-1.424-1.424 1.424 1.424 0 011.424 1.419z","fill":"none","stroke":"#5858ec","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    